import { computed, observable } from "mobx";
import { Type } from "class-transformer";
import DistributorRefundCandidateItemStatus from "./distributorRefundCandidateItemStatus";
import type { ISelectableItem } from "../viewModels/selectableListViewModel";
import VehicleResponse from "./vehicle";
import DistributorRefundCandidatePermittedActionsResponse from "./distributorRefundCandidatePermittedActionsResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class DistributorRefundCandidateResponse {
  id!: string;

  @observable
  @Type(() => Date)
  confirmedAt!: Date;

  @observable
  chargeOrderId!: string;

  @observable
  chargeTypeId!: string;

  /**
   * Price list item Id.
   */
  @observable
  priceListItemId!: string;

  @observable
  salespointId!: string;

  @observable
  amount!: number;

  @observable
  orderIdent!: number;

  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  @observable
  status!: DistributorRefundCandidateItemStatus;

  @observable
  @Type(() => DistributorRefundCandidatePermittedActionsResponse)
  permittedActions!: DistributorRefundCandidatePermittedActionsResponse;
}

export default class DistributorRefundCandidate extends DistributorRefundCandidateResponse implements ISelectableItem {
  @computed
  get isSelectable() {
    return this.status === DistributorRefundCandidateItemStatus.New && this.permittedActions.refundApproval.isAllowed;
  }
}
